module.exports = __webpack_public_path__ + "assets/img/img196.1def78e7.png";